import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Typography,
  DateCTA,
  NewDateFIlterModal as DateFilterModal,
  Loader,
} from "components";
import {
  getAdminStats,
  setAdminDates,
} from "redux/actions/dashboard/onboardingDashboardActions";
import { useWindowDimensions } from "hooks";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

const RegionBreakdown = () => {
  const [openDateModal, setOpenDateModal] = useState(false);

  const { admin } = useSelector((state) => state.onboardingReducer);

  const { width } = useWindowDimensions();

  const isSmallScreen = width < 992;

  const handleModalClose = () => setOpenDateModal(false);

  const { data, loading, dates } = admin || {};

  const getAgentsData = () => {
    getAdminStats(dates);
    handleModalClose();
  };

  useEffect(() => {
    getAgentsData();

    //eslint-disable-next-line
  }, []);

  const { breakdown, totalCount, isError } = data || {};

  const colors = [
    "#102E88",
    "#081A4E",
    "#7B61FF",
    "#1966FC",
    "#79D7F5",
    "#19D3FC",
    "#C9D6FF",
    "#1966FC",
    "#9791CC",
    "#778CA2",
  ];

  const getAdminValues = () => {
    let newBreakdown = [];
    if (breakdown) {
      newBreakdown = breakdown.map((val, i) => ({
        label: val.role,
        value: val.count,
        color: colors[i],
      }));
    }

    return newBreakdown;
  };

  const getColorIndicators = (start, end) =>
    getAdminValues()
      .slice(start, end)
      .map((entry, index) => (
        <div className="mt-3 d-flex align-items-center" key={index}>
          <div
            className="region-indicator-box"
            style={{ backgroundColor: entry.color }}
          ></div>
          <div>
            <Typography variant="caption0" style={{ lineHeight: "17px" }}>
              {entry.label}
            </Typography>
            <Typography variant="body4" style={{ lineHeight: "17px" }}>
              {entry.value}
            </Typography>
          </div>
        </div>
      ));

  useEffect(() => {
    getAdminValues();

    //eslint-disable-next-line
  }, [breakdown]);

  return (
    <div className="dashboard-card">
      <div className="row pt-4 px-4">
        <div className="col-6 text-center">
          <Typography
            className="text-center mt-1 "
            state="primary"
            variant="body0"
          >
            Admin Statistics
          </Typography>
          {loading ? (
            <div
              className={" text-center"}
              style={{ marginTop: "6rem", height: "13rem" }}
            >
              <Loader />
              <Typography state="grey" variant="body2">
                Loading data...
              </Typography>
            </div>
          ) : Number(totalCount) > 0 && !isError ? (
            <div
              style={{
                position: "relative",
                height: "18rem",
              }}
            >
              <ResponsiveContainer width="100%" height="100%">
                <PieChart width={500} height={500}>
                  <Pie
                    data={getAdminValues().map((entry) => ({
                      value: entry.value,
                    }))}
                    dataKey="value"
                    cx="50%"
                    cy="50%"
                    innerRadius={isSmallScreen ? 45 : 70}
                    outerRadius={isSmallScreen ? 70 : 100}
                    fill="#82ca9d"
                    stroke=""
                  >
                    {getAdminValues().map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={
                          getAdminValues().map((entry) => entry.color)[index]
                        }
                      />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
              {totalCount && (
                <div className={`agent-no-agents  text-center`}>
                  <Typography variant="heading4" state="primary">
                    {totalCount}
                  </Typography>
                  <Typography
                    variant="body2"
                    state="primary"
                    style={{ marginTop: "-.5rem" }}
                  >
                    Admins
                  </Typography>
                </div>
              )}
            </div>
          ) : (
            <Typography
              state="grey"
              variant="body2"
              className={" text-center mtop-4 mbottom-4"}
            >
              No information to display
            </Typography>
          )}
        </div>
        <div className="col-6 pt-1">
          <div className="d-flex justify-content-end">
            <DateCTA onClick={() => setOpenDateModal(true)} />
          </div>
          {!loading && totalCount && (
            <div className="mt-2 row">
              <div className="col-6">{getColorIndicators(0, 5)}</div>
              <div className="col-6">
                {getColorIndicators(5, breakdown?.length)}
              </div>
            </div>
          )}
        </div>
      </div>
      <DateFilterModal
        dateFrom={dates.dateFrom}
        dateTo={dates.dateTo}
        openDateModal={openDateModal}
        onClose={handleModalClose}
        handleFromChange={(val) => setAdminDates(val, "dateFrom")}
        handleToChange={(val) => setAdminDates(val, "dateTo")}
        onButtonClick={getAgentsData}
      />
    </div>
  );
};

export default RegionBreakdown;
